import cusHistory from './cusHistory';
import { mobiIng, prompt } from '@/shared/fai';
import {
    signUp,
    sendMemberActiveMail,
    loginMember,
    proceedAfterMail,
    proceedAfterMobile,
    getProContent,
    getMobileCode,
} from '@/api/member';
import { preprocessUrl } from '@/shared/url';
import { changeHref } from '@/features/router/universal';
import { MemberFileUtil } from './fileUpload';
import { logDog } from '@/api/logDog';
import { getPreviewObject } from '@/shared/getPreviewObject';
import { request } from '@/api/request';
import { clueReuqestVm } from '@jz/biz-shared';

import { showMemberLoginMsg } from '@/shared/member';
export const otherLoginErrno = {
    acctAlreadyBind: 1, // 该账号已经被绑定
};

export const selectAnimationCtrl = function (thisnode) {
    if (jm(thisnode).hasClass('selectOpen')) {
        jm(thisnode).blur();
    } else {
        jm(thisnode).addClass('selectOpen');
    }
    selectAnimation(thisnode);
    jm(thisnode).removeClass('selectOpen');
};

// 3.0的下拉箭头的交互效果
export const selectAnimation = function (thisnode) {
    if (jm(thisnode).siblings('.mobileCtIcon').hasClass('hadChangeClass')) {
        jm(thisnode).siblings('.mobileCtIcon').removeClass('hadChangeClass');
        return;
    }
    if (
        jm(thisnode).siblings('.mobileCtIcon').hasClass('selectAnimationRemove')
    ) {
        jm(thisnode).siblings('.mobileCtIcon').addClass('selectAnimation');
        jm(thisnode)
            .siblings('.mobileCtIcon')
            .removeClass('selectAnimationRemove');
        jm(thisnode).siblings('.mobileCtIcon').find('.icon-downward').css({
            '-webkit-transform': 'rotate(-180deg)',
            '-ms-transform': 'rotate(-180deg)',
            '-moz-transform': 'rotate(-180deg)',
            '-o-transform': 'rotate(-180deg)',
            transform: 'rotate(-180deg)',
        });
    } else if (
        jm(thisnode).siblings('.mobileCtIcon').hasClass('selectAnimation')
    ) {
        jm(thisnode)
            .siblings('.mobileCtIcon')
            .addClass('selectAnimationRemove');
        jm(thisnode).siblings('.mobileCtIcon').removeClass('selectAnimation');
        jm(thisnode).siblings('.mobileCtIcon').find('.icon-downward').css({
            '-webkit-transform': 'rotate(0deg)',
            '-ms-transform': 'rotate(0deg)',
            '-moz-transform': 'rotate(0deg)',
            '-o-transform': 'rotate(0deg)',
            transform: 'rotate(0deg)',
        });
    }
};

// 注册页面手机区号
export const signUpPersInfoChangeMobileCt = function (thisnode) {
    var mobleCtVal = jm('#signupPage #mobileCt').val();
    var selectName = jm('#signupPage #mobileCt')
        .find("option[value='" + mobleCtVal + "']")
        .html();
    jm('#signupPage .selectCover').html(
        selectName.substring(selectName.indexOf('+'))
    );

    if (
        jm(thisnode).siblings('.mobileCtIcon').hasClass('selectAnimationRemove')
    ) {
        jm(thisnode).siblings('.mobileCtIcon').addClass('selectAnimation');
        jm(thisnode).siblings('.mobileCtIcon').addClass('hadChangeClass');
        jm(thisnode)
            .siblings('.mobileCtIcon')
            .removeClass('selectAnimationRemove');
        jm(thisnode).siblings('.mobileCtIcon').find('.icon-downward').css({
            transform: 'rotate(-180deg)',
            '-webkit-transform': 'rotate(-180deg)',
            '-ms-transform': 'rotate(-180deg)',
            '-moz-transform': 'rotate(-180deg)',
            '-o-transform': 'rotate(-180deg)',
        });
    } else if (
        jm(thisnode).siblings('.mobileCtIcon').hasClass('selectAnimation')
    ) {
        jm(thisnode)
            .siblings('.mobileCtIcon')
            .addClass('selectAnimationRemove');
        jm(thisnode).siblings('.mobileCtIcon').addClass('hadChangeClass');
        jm(thisnode).siblings('.mobileCtIcon').removeClass('selectAnimation');
        jm(thisnode).siblings('.mobileCtIcon').find('.icon-downward').css({
            transform: 'rotate(0deg)',
            '-webkit-transform': 'rotate(0deg)',
            '-ms-transform': 'rotate(0deg)',
            '-moz-transform': 'rotate(0deg',
            '-o-transform': 'rotate(0deg)',
        });
    }
    return false;
};

export const checkMustItem = function (nodeId) {
    //输入法影响 直接使用keypress up down 会无法检测。 所以加上focusout再次检测
    jm(nodeId)
        .find('.mustItem')
        .on('keyup focusout', function () {
            var flag = true;
            jm(nodeId)
                .find('.mustItem')
                .each(function () {
                    if (jm(this).val().trim() === '') {
                        //必填项有任意一个不填，按钮都会被置成disabled
                        flag = false;
                        return;
                    }
                });
            if (flag === true) {
                jm('.sendIcon').removeAttr('disabled');
            }
        });
};

export const initSignUpPage = function () {
    jm('#signUpMProtocol').on('click', function (event, historyCash) {
        getMProtocol(historyCash);
    });

    cusHistory.init();
};

const getMProtocol = function (historyCash) {
    // 针对商城主题做的处理：商城主题中会将返回入口隐藏
    jm('#mProPage .loginHeader').show();
    jm('#webHeaderBox').hide();
    getProContent()
        .catch(() => {
            mobiIng(LS.memberProfileError);
        })
        .then((data) => {
            if (data.success) {
                jm('#mProPage').find('.title').html(data.proName);
                jm('#mProPage').find('.set-line').html(data.msg);

                window.scrollTo(0, 0);
                jm('#signupPage').hide();
                jm('#mProPage').show();
                cusHistory.add(
                    'signUpMProtocol',
                    historyCash,
                    1,
                    '#signUpMProtocol'
                );
            } else {
                alert('服务器连接错误!');
            }
        });
};

// 注册页面，补充资料页面点击下拉框赋值
export const selectValueChange = function (selectNode) {
    // 监听select值改变
    jm(selectNode + ' select').each(function () {
        if (jm(this).attr('name') == 'mobileCt') {
            return;
        }
        var placeholder = jm(this).siblings('.customIcon').text().trim();
        jm(this)
            .siblings('.selectCover')
            .attr('placeholder', LS.memberOtherLgnPleaseInput + placeholder);
        jm('.selectCover + select').change(function () {
            var selectedOption = jm(this)[0].value;
            jm(this).siblings('.selectCover').val(selectedOption);
            // 如果内容为空，则显示placeholder
            if (selectedOption == null || selectedOption == '') {
                var placeholder = jm(this)
                    .siblings('.customIcon')
                    .text()
                    .trim();
                jm(this)
                    .siblings('.selectCover')
                    .attr(
                        'placeholder',
                        LS.memberOtherLgnPleaseInput + placeholder
                    );
            }
        });
    });
};

// 会员注册改变用户自定义设置项的下拉框默认选中那一项的颜色
export const changeSelectDefaultColor = function (
    unSelectedColor,
    selectColor,
    parentNodeName
) {
    //设置select的默认选中项颜色
    jm(parentNodeName).css('color', unSelectedColor);
    jm(parentNodeName).find('option').css('color', selectColor);
    jm(parentNodeName).change(function () {
        var selItem = jm(this).val();
        if (selItem == jm(this).find('option:first').val()) {
            jm(this).css('color', unSelectedColor);
        } else {
            jm(this).css('color', selectColor);
        }
    });
};

export const checkLabel = (thisnode) => {
    let classname = '';
    if (thisnode.nodeName == 'SPAN') {
        classname = jm(thisnode).attr('class');
        thisnode = jm(thisnode).parent()[0];
    } else {
        classname = jm(thisnode).find('span').attr('class');
    }

    if (classname === 'icon-checkIcon g_mainColor') {
        classname = 'icon-uncheckIcon g_mainColor';
        jm(thisnode).parent().find('input').attr('checked', ''); //将checkbox选上
        jm(thisnode).find('span').attr('class', classname);
    } else if (classname === 'icon-uncheckIcon g_mainColor') {
        classname = 'icon-checkIcon g_mainColor';
        jm(thisnode).parent().find('input').removeAttr('checked');
        jm(thisnode).find('span').attr('class', classname);
    } else if (classname === 'icon-checkIcon g_main_color_v3') {
        //3.0
        classname = 'icon-uncheckIcon';
        jm(thisnode).parent().find('input').attr('checked', '');
        jm(thisnode).find('span').attr('class', classname);
    } else if (classname === 'icon-uncheckIcon') {
        //3.0
        jm(thisnode).parent().find('input').removeAttr('checked');
        classname = 'icon-checkIcon g_main_color_v3';
        jm(thisnode).find('span').attr('class', classname);
    }
};

export const memberSignupSubmit = (url, signUpbyMobile, signUpbyMail) => {
    if (!signUpbyMobile && !signUpbyMail) {
        var acct = jm('#memberSignupAcct').val().trim();
        if (acct == null || acct == '') {
            mobiIng(LS.memberSignupRegisterAcctEmpty);
            document.getElementById('memberSignupAcct').focus();
            return;
        }
    }

    var pwd = jm('#memberSignupPwd').val();
    if (pwd == null || pwd.trim() == '') {
        mobiIng(LS.memberSignupRegisterPwdEmpty);
        document.getElementById('memberSignupPwd').focus();
        return;
    }
    if (pwd.length < 4) {
        mobiIng(LS.memberSignupRegisterPwdMinLength);
        document.getElementById('memberSignupPwd').focus();
        return;
    }
    var repwd = jm('#memberSignupRepwd').val();
    if (pwd != repwd) {
        mobiIng(LS.memberSignupRegisterPwdNotMatch);
        document.getElementById('memberSignupRepwd').focus();
        return;
    }
    var remark = '';
    if (jm('#memberSignupRemark').length > 0) {
        remark = jm('#memberSignupRemark').val().trim();
        var remarkMaxLength = jm('#memberSignupRemark').attr('maxlength');
        if (remark.length > remarkMaxLength) {
            mobiIng(
                jm.format(
                    LS.memberSignupRegisterRemarkMaxLength,
                    remarkMaxLength
                )
            );
            document.getElementById('memberSignupRemark').focus();
            return;
        }
    }

    var info = {};
    info['acct'] = acct;
    info['pwd'] = jm.md5(pwd);
    info['remark'] = remark;
    info['mobileSign'] = Fai.top.tmpMobileCodeSgin;

    info['signUpbyMobile'] = signUpbyMobile;
    info['signUpbyMail'] = signUpbyMail;

    // 判断手机注册的信息
    if (
        typeof jm('#messageAuthCode').attr('maxlength') != 'undefined' &&
        jm('#messageAuthCode').attr('maxlength') != null
    ) {
        var messageAuthCode = jm('#messageAuthCode').val();
        if (
            typeof messageAuthCode == 'undefined' ||
            messageAuthCode == null ||
            messageAuthCode == ''
        ) {
            mobiIng(LS.inputMobileCode);
            document.getElementById('messageAuthCode').focus();
            return;
        } else {
            info['messageAuthCode'] = messageAuthCode;
        }
    }

    var userAddItemName = '';
    var userAddItemID = '';
    var userAddItemValue = '';
    var isUserAddItemNameTooLong = 0;
    var userAddItemMaxLength = '';
    var userAddItemType = '';
    var isUserAddItemPass = 0;
    jm('.userAddItem').each(function () {
        userAddItemID = jm(this).attr('id');
        userAddItemValue = jm(this).val().trim();
        userAddItemName = jm(this).attr('name');
        userAddItemMaxLength = jm(this).attr('maxlength');
        info[userAddItemID] = userAddItemValue;
        if (
            typeof userAddItemMaxLength != 'undefined' &&
            userAddItemMaxLength != null &&
            userAddItemValue.length > userAddItemMaxLength &&
            userAddItemType == 'input'
        ) {
            mobiIng(
                jm.format(
                    LS.memberSignupUserAddItemMaxLength,
                    userAddItemName,
                    userAddItemMaxLength
                )
            );
            document.getElementById(userAddItemID).focus();
            isUserAddItemNameTooLong = 1;
            return false;
        }

        if (userAddItemID == 'email' && userAddItemValue.length > 0) {
            if (!jm.isEmail(userAddItemValue)) {
                mobiIng(
                    jm.format(
                        LS.memberSignupUserAddItemCorrect,
                        userAddItemName
                    )
                );
                document.getElementById(userAddItemID).focus();
                isUserAddItemPass = 1;
                return false;
            }
        }
        if (userAddItemID == 'mobile' && userAddItemValue.length > 0) {
            if (!jm.isNationMobile(userAddItemValue)) {
                mobiIng(LS.mobileNumRegular);
                document.getElementById(userAddItemID).focus();
                isUserAddItemPass = 1;
                return false;
            }
        }

        // 修复3.0手机区号和手机顺序调换之后便利数值被覆盖bug
        if (Fai.top._openThemeV3) {
            if (userAddItemID == 'mobileCt' && info['mobile'].length <= 0) {
                info['mobileCt'] = '';
            }
        } else {
            if (userAddItemID == 'mobile' && userAddItemValue.length <= 0) {
                info['mobileCt'] = '';
            }
        }
    });

    if (isUserAddItemPass == 1) {
        return;
    }
    if (isUserAddItemNameTooLong == 1) {
        return;
    }

    var isCheckUAIStatus = 0;
    jm('.isCheckUAI').each(function () {
        userAddItemID = jm(this).attr('id');
        userAddItemValue = jm(this).val().trim();
        userAddItemName = jm(this).attr('name');

        if (userAddItemValue == null || userAddItemValue.trim() == '') {
            if (jm(this).is('input')) {
                mobiIng(
                    jm.format(
                        LS.memberSignupUserAddItemIsEmpty,
                        userAddItemName
                    )
                );
            } else {
                mobiIng(
                    jm.format(
                        LS.memberSignupUserAddItemIsEmpty2,
                        userAddItemName
                    )
                );
            }
            document.getElementById(userAddItemID).focus();
            isCheckUAIStatus = 1;
            return false;
        }

        if (userAddItemID == 'email' && userAddItemValue.length > 0) {
            if (!jm.isEmail(userAddItemValue)) {
                mobiIng(
                    jm.format(
                        LS.memberSignupUserAddItemCorrect,
                        userAddItemName
                    )
                );
                document.getElementById(userAddItemID).focus();
                isCheckUAIStatus = 1;
                return false;
            }
        }
    });
    if (isCheckUAIStatus == 1) {
        return;
    }

    var memberAgreePro = jm('#memberAgreePro');
    if (memberAgreePro.length > 0) {
        if (!memberAgreePro.prop('checked')) {
            mobiIng(LS.memberAgreeProtocol);
            return;
        }
    }

    /*  var btn = module.find('.memberSignupBtn');
    btn.attr('disabled', true);*/
    var bssKey = 'APuf2tQECAEQARoDWzNdIgnllJDkuJbmsJE';
    var signUpAction = function (checkSign) {
        mobiIng(LS.memberSignupRegisterIng, false, true);
        jm('.g_button').removeClass('sendIcon');
        if (checkSign) {
            info.checkSign = checkSign;
            info.bssKey = bssKey;
        }
        signUp(info)
            .then(async (data) => {
                if (data.success) {
                    await MemberFileUtil.saveMemberFile();
                    Mobi._needSignupFaitest = false;
                    // jm('.mobiIngTigs').remove();
                    if (data.active) {
                        memberActive(
                            info.email,
                            data.acct,
                            url,
                            function () {}
                        );
                    } else {
                        if (data.rt == 0) {
                            changeHref(
                                preprocessUrl({ path: '', oldPath: '' }) +
                                    'login.jsp?errno=-303'
                            );
                        }
                        if (url) {
                            autoLogin(data.acct, pwd, url, 'acct');
                        } else {
                            changeHref(
                                preprocessUrl({ path: '', oldPath: '' }) +
                                    'login.jsp?errno=12'
                            );
                        }
                    }
                } else {
                    /*  btn.removeAttr('disabled');*/
                    jm('.g_button').addClass('sendIcon');
                    jm('.loginIcon ').hide();
                    if (data.rt == -401) {
                        // mobiIng(LS.memberSignupRegisterCaptchaEmpty);
                        if (data.needCode) {
                            Mobi._needSignupFaitest = true;
                            memberSignupSubmit(
                                url,
                                signUpbyMobile,
                                signUpbyMail
                            );
                        }
                    } else if (data.rt == -601) {
                        mobiIng(LS.reGetMobileCode);
                    } else if (data.rt == -8) {
                        mobiIng(LS.mobileHasSigned);
                    } else if (data.rt == -6) {
                        mobiIng(LS.memberSignupRegisterExisted);
                    } else if (data.rt == -4) {
                        mobiIng(LS.memberSignupRegisterLimit);
                    } else if (data.rt == -10) {
                        mobiIng(LS.invalidChar);
                    } else if (data.rt == -28) {
                        mobiIng(LS.memberRegisterLimit);
                    } else if (data.rt == -20 || data.rt == -600) {
                        mobiIng(data.msg);
                    } else if (data.rt == -1001) {
                        jm('#mobiIngTigs').remove();
                        if (Fai.top._openThemeV3) {
                            // 3.0邮箱已被绑定
                            showPluralPopupV3(
                                'email',
                                data.headImg,
                                data.name,
                                data.acct,
                                pwd,
                                info,
                                url
                            );
                        } else {
                            showPluralPopup(
                                'email',
                                data.headImg,
                                data.name,
                                data.acct,
                                pwd,
                                info,
                                url
                            );
                        }
                    } else if (data.rt == -1002) {
                        jm('#mobiIngTigs').remove();
                        if (Fai.top._openThemeV3) {
                            // 3.0手机已被绑定
                            showPluralPopupV3(
                                'mobile',
                                data.headImg,
                                data.name,
                                data.acct,
                                pwd,
                                info,
                                url
                            );
                        } else {
                            showPluralPopup(
                                'mobile',
                                data.headImg,
                                data.name,
                                data.acct,
                                pwd,
                                info,
                                url
                            );
                        }
                    } else {
                        mobiIng(LS.memberSignupRegisterError);
                    }
                    if (data.hasFW) {
                        mobiIng(data.msg);
                    }
                }
            })
            .catch(() => {
                mobiIng(LS.memberSignupRegisterError);
            });
    };
    if (Mobi._needSignupFaitest) {
        // eslint-disable-next-line no-undef
        initFaitest(
            {
                bss: 1,
                bssKey,
            },
            function (checkSign) {
                signUpAction(checkSign);
            }
        );
    } else {
        signUpAction();
    }
};

const autoLogin = function (acct, pwd, url, mode) {
    let option = {
        acct: acct,
        pwd: jm.md5(pwd),
    };
    loginMember(option)
        .then(async (result) => {
            var loginMethod = '';
            if (mode == 'acct') {
                loginMethod = '账号密码登录';
            } else if (mode == 'email') {
                loginMethod = '邮箱登录';
            } else {
                loginMethod = '手机号验证登录';
            }

            if (result.success) {
                await clueReuqestVm.authRecordLoginOther();
                mallBuyLoginCheck();
                jm.cookie('loginMethod', loginMethod, { path: '/' }); //记录登录方式
                changeHref(url);
                return;
            } else {
                changeHref(
                    preprocessUrl({ path: '', oldPath: '' }) +
                        'login.jsp?returnUrl=' +
                        jm.encodeUrl(url)
                );
            }
        })
        .catch(() => {
            showMemberLoginMsg(-1, 'ajax net error');
        });
};

export const mallBuyLoginCheck = function () {
    // 判断试图购买产品的会员是否已经登录
    var mallBuy = localStorage.getItem('mallBuyCallBack');
    if (mallBuy) {
        localStorage.removeItem('mallBuyCallBack');
        mallBuy = jm.parseJSON(mallBuy);
        mallBuy.login = true;
        localStorage.setItem('mallBuyCallBack', jm.toJSON(mallBuy));
    }
};

export const memberActive = function (mEmail, memName) {
    //注册完执行一次发送激活邮件
    sendMemberActiveMail(jm.encodeUrl(memName), mEmail)
        .then(() => {
            jm('#profileArea').hide();
            jm('#fillAcctInfo').hide();
            jm('#mSignUp').show();
            jm('#mSignUp .loginContent').hide();
            jm('.loginErrorLine').hide();
            var msg = getEmailCarriersAddress(mEmail);
            jm('#checkEmail').html(
                jm.format(LS.memberSignupMailActivation, mEmail)
            );
            if (msg != -1) {
                jm('#emailAddr').attr('href', msg.addr);
                jm('#emailAddr').html(
                    jm.format(LS.memberSignupMailActivationLink, msg.name)
                );
                jm('#emailAddr').show();
            }
            jm('#mobiIngTigs').remove();
        })
        .catch(() => {
            mobiIng(LS.js_systemError);
        });
};

const getEmailCarriersAddress = function (mEmail) {
    var msg = {};
    var mailAddr = mEmail.split('@')[1];
    if (
        mailAddr === 'qq.com' ||
        mailAddr === 'vip.qq.com' ||
        mailAddr === 'foxmail.com'
    ) {
        msg.name = 'QQ';
        msg.addr = '//w.mail.qq.com';
        return msg;
    } else if (mailAddr === '163.com') {
        msg.name = '163';
        msg.addr = '//smart.mail.163.com';
        return msg;
    } else if (mailAddr === '126.com') {
        msg.name = '126';
        msg.addr = '//smart.mail.126.com';
        return msg;
    } else if (mailAddr === 'sina.com' || mailAddr === 'vip.sina.com') {
        msg.name = 'sina';
        msg.addr = '//mail.sina.com.cn';
        return msg;
    } else {
        return -1;
    }
};

// 主题3.0邮箱已被绑定
const showPluralPopupV3 = function (mode, headImg, name, acct, pwd, info, url) {
    var tip =
            mode == 'email'
                ? LS.emailAlreadyRegister
                : LS.mobileAlreadyRegister,
        tryToRegister = mode == 'email' ? info.email : info.mobile;

    var options = {
        textClass: 'proceed',
        cancelClass: 'loginInstantly',
        content: tip,
        insertSelector: '#g_body',
        callback() {
            proceedRegistry();
        },
        cancelCallback() {
            changeHref(preprocessUrl({ path: '', oldPath: '' }) + 'login.jsp');
        },
    };

    let sendAjax = mode == 'email' ? proceedAfterMail : proceedAfterMobile;

    prompt(options);

    function proceedRegistry() {
        var proceedContent = [];
        proceedContent.push(
            "<div class='confirmCancelEmail'>" +
                jm.format(LS.warningBeforeProceedRegistry, tryToRegister) +
                '</div>'
        );

        var proceedOptions = {
            promptWrap: 'confirmCancelEmailWrap',
            textClass: 'confirm',
            insertSelector: '#g_body',
            content: proceedContent.join(''),
            callback() {
                sendAjax(info)
                    .catch(() => {
                        mobiIng(LS.memberSignupRegisterError);
                    })
                    .then((data) => {
                        if (data.success) {
                            if (data.active) {
                                memberActive(
                                    info.email,
                                    data.acct,
                                    url,
                                    function () {}
                                );
                            } else {
                                if (data.rt == 0) {
                                    changeHref(
                                        preprocessUrl({
                                            path: '',
                                            oldPath: '',
                                        }) + 'login.jsp?errno=-303'
                                    );
                                }
                                if (url) {
                                    autoLogin(data.acct, pwd, url, mode);
                                } else {
                                    changeHref(
                                        preprocessUrl({
                                            path: '',
                                            oldPath: '',
                                        }) + 'login.jsp?errno=12'
                                    );
                                }
                            }
                        } else {
                            /*  btn.removeAttr('disabled');*/
                            jm('.g_button').addClass('sendIcon');
                            jm('.loginIcon ').hide();
                            jm('#signupCaptchaImg').attr(
                                'src',
                                'validateCode.jsp?' + Math.random() * 1000
                            );
                            jm('#memberSignupCaptcha').val('');
                            if (data.rt == -401) {
                                mobiIng(LS.memberSignupRegisterCaptchaNotMatch);
                                if (data.needCode) {
                                    jm('.J_memberSignupCaptcha').removeClass(
                                        'memberSignupCaptchaHide'
                                    );
                                }
                            } else if (data.rt == -601) {
                                mobiIng(LS.reGetMobileCode);
                            } else if (data.rt == -8) {
                                mobiIng(LS.mobileHasSigned);
                            } else if (data.rt == -6) {
                                mobiIng(LS.memberSignupRegisterExisted);
                            } else if (data.rt == -4) {
                                mobiIng(LS.memberSignupRegisterLimit);
                            } else if (data.rt == -10) {
                                mobiIng(LS.invalidChar);
                            } else if (data.rt == -28) {
                                mobiIng(LS.memberRegisterLimit);
                            } else if (data.rt == -20) {
                                mobiIng(data.msg);
                            } else if (data.rt == -1001) {
                                if (Fai.top._openThemeV3) {
                                    showPluralPopupV3(
                                        'email',
                                        data.headImg,
                                        data.name,
                                        data.acct,
                                        pwd,
                                        info,
                                        url
                                    );
                                } else {
                                    showPluralPopup(
                                        'email',
                                        data.headImg,
                                        data.name,
                                        data.acct,
                                        pwd,
                                        info,
                                        url
                                    );
                                }
                            } else if (data.rt == -1002) {
                                if (Fai.top._openThemeV3) {
                                    showPluralPopupV3(
                                        'mobile',
                                        data.headImg,
                                        data.name,
                                        data.acct,
                                        pwd,
                                        info,
                                        url
                                    );
                                } else {
                                    showPluralPopup(
                                        'mobile',
                                        data.headImg,
                                        data.name,
                                        data.acct,
                                        pwd,
                                        info,
                                        url
                                    );
                                }
                            } else if (data.rt == -1500) {
                                // 继续注册
                            } else {
                                mobiIng(LS.memberSignupRegisterError);
                            }
                            if (data.hasFW) {
                                mobiIng(data.msg);
                            }
                        }
                    });
            },
        };

        prompt(proceedOptions);
    }
};

const showPluralPopup = function (mode, headImg, name, acct, pwd, info, url) {
    var tip = mode == 'email' ? LS.emailAcct : LS.mobileNum,
        tryToRegister = mode == 'email' ? info.email : info.mobile;

    var nameToShow =
        typeof name == 'undefined' || name == '' || name == 'null'
            ? acct
            : name;

    var content = [];
    content.push(
        "<div style='position: relative; top: -1.094rem; left: -.125rem; display: inline-block; width: 3.875rem; height: 3.875rem;'>"
    );
    content.push(
        '	<img src=' +
            headImg +
            " style='height: 3.875rem; width: 3.875rem; border-radius: 100%; border: .125rem #f2f2f2 solid;' />"
    );
    content.push('</div>');
    content.push(
        "<div style='font-size: .75rem; color: #333; position: relative; top: -.375rem;'>"
    );
    content.push(
        "	<span style='display: block; text-align: center;'>" +
            nameToShow +
            '</span>'
    );
    content.push(
        "	<span style='display: block; text-align: center; position: relative; top: .4rem'>" +
            jm.format(LS.alreadyHasAnAcct, tip) +
            '</span>'
    );
    content.push('</div>');

    var options = {
        textClass: 'proceed',
        cancelClass: 'loginInstantly',
        content: content.join(''),
        insertSelector: '#g_body',
        callback() {
            proceedRegistry();
        },
        cancelCallback() {
            changeHref(preprocessUrl({ path: '', oldPath: '' }) + 'login.jsp');
        },
    };

    prompt(options);

    let sendAjax = mode == 'email' ? proceedAfterMail : proceedAfterMobile;

    function proceedRegistry() {
        var proceedContent = [];
        proceedContent.push(
            "<div style='width: 2.5rem; height: 2.5rem; border-radius:50%; border: .125rem solid gray; position: relative; top: -.625rem; left: 4.0625rem; border-color: #F8BB86;'>"
        );
        proceedContent.push(
            "<div style='animation: pulseWarningIns 0.75s infinite alternate; -webkit-animation: pulseWarningIns 0.75s infinite alternate;'>"
        );
        proceedContent.push(
            "<span style='position: absolute; width: 0.15625rem; height: 1.46875rem; left: 50%; top: .3125rem; webkit-border-radius: .0625rem; border-radius: .0625rem; margin-left: -.0625rem; background-color: #F8BB86;'></span>"
        );
        proceedContent.push(
            "<span style='position: absolute; width: .21875rem; height: .21875rem; -webkit-border-radius: 50%; border-radius: 50%; margin-left: .09375rem; left: 42%; bottom: .3125rem; background-color: #F8BB86;'></span>"
        );
        proceedContent.push('</div>');
        proceedContent.push('</div>');
        proceedContent.push(
            "<div style='color: #333; font-size: .75rem; text-align:center;'>" +
                jm.format(LS.warningBeforeProceedRegistry, tryToRegister) +
                '</div>'
        );

        var proceedOptions = {
            textClass: 'confirm',
            content: proceedContent.join(''),
            insertSelector: '#g_body',
            callback() {
                sendAjax(info)
                    .catch(() => {
                        mobiIng(LS.memberSignupRegisterError);
                    })
                    .then((data) => {
                        if (data.success) {
                            if (data.active) {
                                memberActive(
                                    info.email,
                                    data.acct,
                                    url,
                                    function () {}
                                );
                            } else {
                                if (data.rt == 0) {
                                    changeHref(
                                        preprocessUrl({
                                            path: '',
                                            oldPath: '',
                                        }) + 'login.jsp?errno=-303'
                                    );
                                }
                                if (url) {
                                    autoLogin(data.acct, pwd, url, mode);
                                } else {
                                    changeHref(
                                        preprocessUrl({
                                            path: '',
                                            oldPath: '',
                                        }) + 'login.jsp?errno=12'
                                    );
                                }
                            }
                        } else {
                            /*  btn.removeAttr('disabled');*/
                            jm('.g_button').addClass('sendIcon');
                            jm('.loginIcon ').hide();
                            jm('#signupCaptchaImg').attr(
                                'src',
                                'validateCode.jsp?' + Math.random() * 1000
                            );
                            jm('#memberSignupCaptcha').val('');
                            if (data.rt == -401) {
                                mobiIng(LS.memberSignupRegisterCaptchaNotMatch);
                                if (data.needCode) {
                                    jm('.J_memberSignupCaptcha').removeClass(
                                        'memberSignupCaptchaHide'
                                    );
                                }
                            } else if (data.rt == -601) {
                                mobiIng(LS.reGetMobileCode);
                            } else if (data.rt == -8) {
                                mobiIng(LS.mobileHasSigned);
                            } else if (data.rt == -6) {
                                mobiIng(LS.memberSignupRegisterExisted);
                            } else if (data.rt == -4) {
                                mobiIng(LS.memberSignupRegisterLimit);
                            } else if (data.rt == -10) {
                                mobiIng(LS.invalidChar);
                            } else if (data.rt == -28) {
                                mobiIng(LS.memberRegisterLimit);
                            } else if (data.rt == -20) {
                                mobiIng(data.msg);
                            } else if (data.rt == -1001) {
                                if (Fai.top._openThemeV3) {
                                    showPluralPopupV3(
                                        'email',
                                        data.headImg,
                                        data.name,
                                        data.acct,
                                        pwd,
                                        info,
                                        url
                                    );
                                } else {
                                    showPluralPopup(
                                        'email',
                                        data.headImg,
                                        data.name,
                                        data.acct,
                                        pwd,
                                        info,
                                        url
                                    );
                                }
                            } else if (data.rt == -1002) {
                                if (Fai.top._openThemeV3) {
                                    showPluralPopupV3(
                                        'mobile',
                                        data.headImg,
                                        data.name,
                                        data.acct,
                                        pwd,
                                        info,
                                        url
                                    );
                                } else {
                                    showPluralPopup(
                                        'mobile',
                                        data.headImg,
                                        data.name,
                                        data.acct,
                                        pwd,
                                        info,
                                        url
                                    );
                                }
                            } else if (data.rt == -1500) {
                                // 继续注册
                            } else {
                                mobiIng(LS.memberSignupRegisterError);
                            }
                            if (data.hasFW) {
                                mobiIng(data.msg);
                            }
                        }
                    });
            },
        };

        prompt(proceedOptions);
    }
};

// 获取注册手机短信验证码
export const getSignMobileCode = /*#__PURE__*/ function (showCaptcha) {
    if (VITE_APP_MODE !== 'visitor') {
        mobiIng(
            '您目前处于网站管理状态，请先点击网站右上方的“退出”后再获取短信验证码。'
        );
        return;
    }

    var mobile = jm('#mobile').val(),
        mobileCt = jm('#mobileCt').val(),
        mCode = '';

    if (!jm.isNationMobile(mobile)) {
        mobiIng(LS.mobileNumRegular);
        return;
    }

    if (showCaptcha) {
        Fai._needFaitest = true;
    }

    if (Fai.top._encryptType) {
        if (
            typeof mobile != 'undefined' &&
            Fai.top._faiEncryptKey &&
            Fai.top._encryptType > 0
        ) {
            // eslint-disable-next-line no-undef
            var encrypt = new JSEncrypt();
            encrypt.setPublicKey(Fai.top._faiEncryptKey);

            if (Fai.top._encryptType == 1) {
                // eslint-disable-next-line no-undef
                encrypt = new JSEncrypt1();
            } else if (Fai.top._encryptType == 2) {
                // eslint-disable-next-line no-undef
                encrypt = new JSEncrypt2();
            } else if (Fai.top._encryptType == 3) {
                // eslint-disable-next-line no-undef
                encrypt = new JSEncrypt3();
            }
            encrypt.setPublicKey(Fai.top._faiEncryptKey);
            mCode = encrypt.encrypt(mobile);
        }
    }
    var bssKey = 'AObmzq0GCAEQARoDWzldIgnllJDkuJbmsJE'; //获取手机验证码滑动验证的场景bsskey
    var getCodeAction = function (checkSign) {
        let paramData = {
            mobile,
            mobileCt,
            mCode,
        };
        if (checkSign) {
            paramData.bssKey = bssKey;
            paramData.checkSign = checkSign;
        }
        getMobileCode(paramData)
            .then((data) => {
                if (data.success) {
                    mobiIng(LS.sendMobileCodeSuc);
                    getSignMobileCodeCountDown();
                    Mobi._needFaitest = false;
                    Fai.top.tmpMobileCodeSgin = data.mobileCodeSign;
                } else {
                    if (data.needCode) {
                        Mobi._needFaitest = true;
                        getSignMobileCode();
                    }
                    if (data.rt == -401) {
                        if (!data.needCode) {
                            mobiIng(LS.memberSignupRegisterCaptchaNotMatch);
                        }
                    } else if (data.rt == -2) {
                        mobiIng(LS.js_argsError);
                    } else if (data.rt == 2) {
                        mobiIng(LS.memberDialogSendMobileCodeErr);
                    } else if (data.rt == -4 || data.rt == 8) {
                        mobiIng(LS.getMobileOneMin);
                    } else if (data.rt == -8) {
                        mobiIng(LS.getMobileHalfHour);
                    } else if (data.rt == 3) {
                        mobiIng(LS.memberDialogMobileMoneyErr);
                    } else if (data.rt == 9) {
                        mobiIng(LS.memberDialogSendMobileCodeLimit);
                    } else if (data.rt == 101) {
                        mobiIng(LS.mobileSetErr);
                    } else if (data.rt == -6) {
                        mobiIng(LS.mobileHasSigned);
                    } else if (data.rt == 23) {
                        mobiIng(LS.mobileNationTplErr);
                    } else if (data.rt == -301) {
                        mobiIng(LS.smsRanout);
                    } else if (data.rt == -1002) {
                        // Mobi.showPluralPopup("mobile", data.headImg, data.name, data.acct, info);
                    } else {
                        mobiIng(LS.getMobileRefresh);
                    }
                }
            })
            .catch(() => {
                mobiIng(LS.getMobileCodeErrAf);
            });
    };

    if (Mobi._needFaitest) {
        // eslint-disable-next-line no-undef
        initFaitest(
            {
                bss: 1,
                bssKey,
            },
            function (checkSign) {
                getCodeAction(checkSign);
            }
        );
    } else {
        getCodeAction();
    }
};

// 获取手机验证码的倒计时
export const getSignMobileCodeCountDown = function (time, setWidth) {
    var getMobileCdBtn = jm('#messageAuthCodeClick');
    var cTime = getMobileCdBtn.attr('cTime');
    var downTime = 60;
    var width = '5.2rem';
    if (!cTime || cTime == null) {
        cTime = 0;
    } else {
        width = '5.6rem';
        cTime = parseInt(cTime);
        downTime = 1800;
    }
    if (time) {
        downTime = time;
    }
    if (setWidth) {
        width = setWidth;
    }
    cTime++;
    getMobileCdBtn.attr('cTime', cTime);
    getMobileCdBtn.attr('s_onclick', getMobileCdBtn.attr('onclick'));
    getMobileCdBtn.removeAttr('onclick');
    getMobileCdBtn.css('width', width);
    if (Mobi.mobileCodeCountInterval) {
        clearInterval(Mobi.mobileCodeCountInterval);
    }
    Mobi.mobileCodeCountInterval = setInterval(function () {
        downTime--;
        getMobileCdBtn.html(LS.reGetMsg + '(' + downTime + ')');
        if (downTime <= 0) {
            getMobileCdBtn.html(getMobileCdBtn.attr('title'));
            getMobileCdBtn.css('width', '4.2rem');
            getMobileCdBtn.attr('onclick', getMobileCdBtn.attr('s_onclick'));
            clearInterval(Mobi.mobileCodeCountInterval);
        }
    }, 1000);
};

export const bindOtherAcct = function (
    srcMid,
    optionsList,
    noRemark,
    remarkMaxLen,
    mobileCtNameList,
    signNeenMobile
) {
    var sendBtnV3 = Fai.top._openThemeV3 ? ' g_main_bgColor_v3 fpw_btn ' : '';
    var value = Fai.top._openThemeV3
        ? LS.memberOtherLgnBindNowV3
        : LS.memberOtherLgnBindNow;
    var profile_v3_msg_icon = Fai.top._openThemeV3 ? 'profile_v3_msg_icon' : '';
    var loginType = jm.cookie('isOtherLogin');
    var divHtml = "<div class='g_globalLine'>";
    divHtml +=
        "	<input type='text' maxlength='50'  id='bindUser' class='itemEdit g_input mustItem ' placeholder='" +
        LS.memberSignupRegisterAcctEmpty +
        "'/><span class='icon-userIcon g_mainColor g_main_color_v3 " +
        profile_v3_msg_icon +
        "'></span>";
    divHtml += '</div>';
    divHtml += "<div class='g_globalLine'>";
    divHtml +=
        "	<input type='password'maxlength='20' id='bindPassword' class='itemEdit g_input  mustItem '  placeholder='" +
        LS.memberDialogPleaseEnterPwd +
        "'/><span class='icon-pswIcon g_mainColor g_main_color_v3 " +
        profile_v3_msg_icon +
        "'></span>";
    divHtml += '</div>';
    divHtml += "<div class='g_globalLine'>";
    divHtml +=
        "<input type='button'  class=' g_button sendIcon " +
        sendBtnV3 +
        "' value='" +
        value +
        "'/>";
    divHtml += '</div>';
    if (Fai.top._openThemeV3) {
        divHtml +=
            "<div id='signUp' class='g_globalLine' style='text-align:center; margin-top:0.75rem; color:#666666; font-size:0.55rem;'>" +
            LS.memberSignUpNewAcct +
            '</div>';
    } else {
        divHtml +=
            "<div id='signUp' class='g_globalLine' style='text-align:right; margin-top:0.4rem;'>" +
            LS.memberSignUpNewAcct +
            '</div>';
    }
    if (!jm('#bindOtherAcct .loginContent').children().length) {
        jm('#bindOtherAcct .loginContent').append(divHtml);
    }

    jm('#signUp').click(function () {
        logDog(200199, 6);
        signUpFunc(
            srcMid,
            optionsList,
            noRemark,
            remarkMaxLen,
            loginType,
            mobileCtNameList,
            signNeenMobile
        );
    });
    jm('#changeOtherLoginAcct').click(function () {
        logDog(200199, 4);
        jm('#profile').hide();
        jm('#bindOtherAcct').show();
        jm('#bindOtherAcct #bindAcctBack').click(function () {
            jm('#bindOtherAcct').hide();
            jm('#profile').show();
        });
    });
    jm('.sendIcon').click(function () {
        bindOtherAcctSubmit(srcMid, true, loginType);
    });
};

// 从绑定其他账号跳转到的注册页面
const signUpFunc = function (
    srcMid,
    optionList,
    noRemark,
    remarkMaxLen,
    loginType,
    mobileCtNameList,
    signNeenMobile
) {
    var divHtml = [],
        tagWidth = '';
    optionList = jm.parseJSON(optionList);
    mobileCtNameList = jm.parseJSON(mobileCtNameList);
    var input_style = Fai.top._openThemeV3 ? ' input_plceholder_v3 ' : ' ';
    var input_tip_v3 = Fai.top._openThemeV3 ? ' input_tip_v3 ' : ' ';
    var mobileTip = Fai.top._openThemeV3 ? LS.mobileArea : LS.mobileAreaCode;
    var register_line = Fai.top._openThemeV3 ? ' register_line ' : ' ';

    if (checkHasMobileOption(optionList)) {
        tagWidth = 'tagWidth8';
    }
    var itemIcon = '';
    divHtml.push("<div class='g_globalLine " + tagWidth + "'>");
    divHtml.push(
        "<input type='text' maxlength='50' id='memberSignupAcct' class='mustItem itemEdit userAddItem g_input " +
            input_style +
            "' placeholder='" +
            LS.memberSignupRegisterAcctEmpty +
            LS.memberOtherLgnMust +
            "'><span class='icon-userIcon g_mainColor g_main_color_v3 input_tip_v3'></span>"
    );
    divHtml.push('</div>');
    divHtml.push("<div class='g_globalLine " + tagWidth + "'>");
    divHtml.push(
        "<input type='password'  maxlength='20' id='memberSignupPwd' class='mustItem itemEdit icon-pswIcon userAddItem g_input " +
            input_style +
            "' placeholder='" +
            LS.memberDialogPleaseEnterPwd +
            LS.memberOtherLgnMust +
            "'><span class='icon-pswIcon g_mainColor g_main_color_v3 input_tip_v3'></span>"
    );
    divHtml.push('</div>');
    divHtml.push("<div class='g_globalLine " + tagWidth + "'>");
    divHtml.push(
        "<input type='password'  maxlength='20' id='memberSignupRepwd' class='mustItem itemEdit icon-pswIcon userAddItem g_input " +
            input_style +
            "' placeholder='" +
            LS.memberDialogPleaseEnterPwd2 +
            LS.memberOtherLgnMust +
            "'><span class='icon-pswIcon g_mainColor g_main_color_v3 input_tip_v3'></span>"
    );
    divHtml.push('</div>');
    jm.each(optionList, function (i, n) {
        var customPropName = '';
        if (n.fieldKey == 'email') {
            itemIcon = 'icon-emailIcon g_mainColor g_main_color_v3';
        } else if (n.fieldKey == 'name') {
            itemIcon = 'icon-nameIcon g_mainColor g_main_color_v3';
        } else {
            itemIcon = 'icon-customIcon g_mainColor g_main_color_v3';
            customPropName = 'customIcon';
        }
        var placeholder = '';
        if (n.placeholder == n.name) {
            placeholder = LS.memberOtherLgnPleaseInput + n.name;
        } else {
            placeholder = n.placeholder;
        }

        if (n.fieldKey == 'mobile') {
            divHtml.push(
                "<div class='g_globalLine " +
                    tagWidth +
                    ' ' +
                    register_line +
                    "'>"
            );

            // 3.0的手机区号和手机号码一行显示
            if (Fai.top._openThemeV3) {
                divHtml.push(
                    "<input type='text' maxlength='50' id='mobile' name='" +
                        LS.mobileArea +
                        "' style='width:65%' class='addCtTel mustItem itemEdit userAddItem isCheckUAI g_input maxlength='11' loginTelInput ' placeholder='" +
                        LS.memberOtherLgnPleaseInput +
                        '' +
                        LS.mobileArea +
                        '' +
                        LS.memberOtherLgnMust +
                        "'>"
                );
                divHtml.push(
                    "<div class='mobileCtIcon otherSettingIcon icon-downward'></div>"
                );
                divHtml.push(
                    "<div class='g_input selectCover selectCoverRight'>+86</div>"
                );
                divHtml.push(
                    "<select id='mobileCt' name='mobileCt' class='itemEdit g_select'>"
                );
            } else {
                divHtml.push(
                    "<select id='mobileCt' name='mobileCt' class='itemEdit g_select'>"
                );
            }
            for (var j = 0; j < mobileCtNameList.length; j++) {
                divHtml.push(
                    "<option value='" +
                        mobileCtNameList[j]['ctName'] +
                        "'>" +
                        mobileCtNameList[j]['ctShowName'] +
                        mobileCtNameList[j]['ctCode'] +
                        '</option>'
                );
            }
            divHtml.push('</select>');
            if (
                (!Fai.top._openThemeV3 &&
                    Fai.top._other.templateInfo.templateDesignType != 2) ||
                Fai.top._openThemeV3
            ) {
                divHtml.push(
                    "<span class='" +
                        customPropName +
                        "'>" +
                        mobileTip +
                        '</span>'
                );
            }
            divHtml.push('</div>');
        }

        if (
            !Fai.top._openThemeV3 ||
            (Fai.top._openThemeV3 && n.fieldKey != 'mobile')
        ) {
            divHtml.push("<div class='g_globalLine " + tagWidth + "'>");
            var placeHolderStr = placeholder;
            var mustClass = '';
            if (n.must) {
                mustClass = 'mustItem isCheckUAI ';
                placeHolderStr = placeholder + LS.memberOtherLgnMust;
            }
            if (n.pt == 0) {
                divHtml.push(
                    "<input type='text' maxlength='50' id='" +
                        n.fieldKey +
                        "' name='" +
                        n.name +
                        "' class='" +
                        mustClass +
                        ' itemEdit userAddItem  g_input ' +
                        input_style +
                        "' maxlength='50' placeholder='" +
                        placeHolderStr +
                        "'>"
                );
            } else {
                if (Fai.top._openThemeV3) {
                    divHtml.push(
                        "<div class='mobileCtIcon otherSettingIcon icon-downward'></div>"
                    );
                    divHtml.push("<input class='g_input selectCover'>");
                }
                var firstOptionStr = n.name;
                if (n.must) {
                    firstOptionStr = n.name + LS.memberOtherLgnMust;
                }
                divHtml.push(
                    "<select id='" +
                        n.fieldKey +
                        "' name='" +
                        n.name +
                        "' class='" +
                        mustClass +
                        " itemEdit userAddItem g_select' placeholder='" +
                        placeHolderStr +
                        "'>"
                );
                divHtml.push(
                    "<option value=''>" + firstOptionStr + '</option>'
                );
                for (let i = 0; i < n.pc.length; i++) {
                    divHtml.push(
                        "<option value='" +
                            n.pc[i] +
                            "'>" +
                            n.pc[i] +
                            '</option>'
                    );
                }
                divHtml.push('</select>');
            }

            if (
                (!Fai.top._openThemeV3 &&
                    Fai.top._other.templateInfo.templateDesignType != 2) ||
                Fai.top._openThemeV3
            ) {
                divHtml.push(
                    "<span class='" +
                        itemIcon +
                        ' ' +
                        input_tip_v3 +
                        "'></span>"
                );
            }
            if (
                (!Fai.top._openThemeV3 &&
                    Fai.top._other.templateInfo.templateDesignType != 2) ||
                Fai.top._openThemeV3
            ) {
                if (customPropName != '') {
                    divHtml.push(
                        "<span class='" +
                            customPropName +
                            "'>" +
                            n.name +
                            '</span>'
                    );
                }
            }
            divHtml.push('</div>');
        }
    });
    if (noRemark) {
        divHtml.push("<div class='g_globalLine " + tagWidth + "'>");
        divHtml.push(
            "<input type='text' class='itemEdit g_input userAddItem " +
                input_style +
                "' id='memberSignupRemark' maxlength='200' placeholder='" +
                LS.memberOtherLgnRemark +
                "'>"
        );
        if (
            !Fai.top._openThemeV3 &&
            Fai.top._other.templateInfo.templateDesignType != 2
        ) {
            divHtml.push(
                "<span class='icon-msgIcon g_mainColor g_main_color_v3 input_tip_v3'></span>"
            );
        } else if (Fai.top._openThemeV3) {
            divHtml.push(
                "<span class='icon-msgIcon g_mainColor g_main_color_v3 input_tip_v3'>" +
                    LS.msgBoardSaidV3 +
                    '</span>'
            );
        }
        divHtml.push('</div>');
    }
    if (signNeenMobile) {
        divHtml.push("<div class='g_globalLine '>");
        divHtml.push(
            "<input id='memberSignupCaptcha' type='text' class='captchaText g_input " +
                input_style +
                "' maxlength='4' placeholder='" +
                LS.EnterVerificationCode +
                "'/><img id='signupCaptchaImg'  class='captchaImg' src='validateCode.jsp?" +
                Math.random() * 1000 +
                "/><span class='icon-signupCaptchaIcon g_mainColor g_main_color_v3 input_tip_v3'></span><div style='clear:both'></div>"
        );
        divHtml.push('</div>');

        divHtml.push("<div class='g_globalLine '>");
        divHtml.push(
            "<input id='messageAuthCode' type='text' class='captchaText g_input " +
                input_style +
                "' maxlength='6' placeholder='" +
                LS.inputMobileCode +
                "' /><span class='icon-signupMobileCaptchaIcon g_mainColor g_main_color_v3 input_tip_v3'></span><div id='messageAuthCodeClick' class='fk-sign-getMobileCode' title='" +
                LS.getMobileCode +
                "'>" +
                LS.getMobileCode +
                "</div><div style='clear:both'></div>"
        );
        divHtml.push('</div>');
    }

    if (loginType == 1) {
        divHtml.push(
            "<div style='margin-top:0.5rem;font-size:0.6rem;color:#999;width:12rem;'>" +
                LS.signByQQCanLogin +
                '</div>'
        );
    } else if (loginType == 2) {
        divHtml.push(
            "<div style='margin-top:0.5rem;font-size:0.6rem;color:#999;width:13.5rem;'>" +
                LS.signByWbCanLogin +
                '</div>'
        );
    } else {
        divHtml.push(
            "<div style='margin-top:0.5rem;font-size:0.6rem;color:#999;width:13.5rem;'>" +
                LS.signByWXCanLogin +
                '</div>'
        );
    }
    divHtml.push(
        "<div class='signupSubmitCtrl g_globalLine " + tagWidth + "'>"
    );
    divHtml.push(
        "<input type='button'  class='g_button g_main_bgColor_v3  sendIcon signupSubmit submitIcon fpw_btn' value='" +
            LS.memberOtherLgnSignUp +
            "'/>"
    );
    divHtml.push('</div>');

    if (!jm('#mSignUp .loginContent').children().length) {
        if (Fai.top._openThemeV3) {
            jm('#mSignUp .loginContent').addClass('bindSignUpV3Line');
            jm('#mSignUp .loginContent input').addClass(
                'input_tip_v3, input_plceholder_v3'
            );
        }
        jm('#mSignUp .loginContent').append(divHtml.join(''));
    }

    jm('#mSignUp').show();
    jm('#bindOtherAcct').hide();
    jm('#mSignUp #signUpBack').click(function () {
        jm('#mSignUp').hide();
        jm('#bindOtherAcct').show();
    });

    jm('#messageAuthCodeClick')
        .unbind('click')
        .bind('click', function () {
            getSignMobileCode();
        });

    jm('#signupCaptchaImg')
        .unbind('click')
        .bind('click', function () {
            // eslint-disable-next-line no-undef
            changeValidateCode('#signupCaptchaImg');
        });

    jm('.signupSubmit').bind('click', function () {
        bindOtherAcctSubmit(srcMid, false, loginType);
    });

    if (Fai.top._openThemeV3) {
        selectValueChange('#mSignUp');
        jm('#mobileCt').bind('change', function () {
            mSignUpPersInfoChangeMobileCt();
        });
    }
};

const bindOtherAcctSubmit = function (srcMid, isBindOtherAcct, loginType) {
    var cmd = '';
    var acct;
    var pwd;
    var info = {};
    if (isBindOtherAcct) {
        logDog(200199, 5);
        cmd = 'cmd=setWafCk_bindOtherAcct';
        acct = jm('#bindUser').val();
        pwd = jm('#bindPassword').val();
        if (acct == null || acct == '') {
            mobiIng(LS.memberSignupRegisterAcctEmpty);
            getPreviewObject('bindUser').focus();
            return;
        }
        if (pwd == null || pwd == '') {
            mobiIng(LS.memberSignupRegisterPwdEmpty);
            getPreviewObject('bindPassword').focus();
            return;
        }
        pwd = jm.md5(pwd);
        info['acct'] = acct;
        info['pwd'] = pwd;
    } else {
        cmd = 'cmd=wafNotCk_signUpAndBind';
        acct = jm('#memberSignupAcct').val();
        if (acct == null || acct == '') {
            mobiIng(LS.memberSignupRegisterAcctEmpty);
            getPreviewObject('memberSignupAcct').focus();
            return;
        }

        pwd = jm('#memberSignupPwd').val();
        if (pwd == null || pwd == '') {
            mobiIng(LS.memberSignupRegisterPwdEmpty);
            getPreviewObject('memberSignupPwd').focus();
            return;
        }
        if (pwd.length < 4) {
            mobiIng(LS.memberSignupRegisterPwdMinLength);
            getPreviewObject('memberSignupPwd').focus();
            return;
        }
        var repwd = jm('#memberSignupRepwd').val();
        if (pwd != repwd) {
            mobiIng(LS.memberSignupRegisterPwdNotMatch);
            getPreviewObject('memberSignupRepwd').focus();
            return;
        }
        var remark = '';
        if (jm('#memberSignupRemark').length > 0) {
            remark = jm('#memberSignupRemark').val();
            var remarkMaxLength = jm('#memberSignupRemark').attr('maxlength');
            if (remark.length > remarkMaxLength) {
                mobiIng(
                    jm.format(
                        LS.memberSignupRegisterRemarkMaxLength,
                        remarkMaxLength
                    )
                );
                getPreviewObject('memberSignupRemark').focus();
                return;
            }
        }
        info['acct'] = acct;
        info['pwd'] = jm.md5(pwd);
        info['remark'] = remark;
        info['mobileSign'] = Fai.top.tmpMobileCodeSgin;

        var userAddItemName = '';
        var userAddItemValue = '';
        var isUserAddItemNameTooLong = 0;
        var userAddItemMaxLength = '';
        var isUserAddItemPass = 0;
        jm('#mSignUp .userAddItem').each(function () {
            let userAddItemID = jm(this).attr('id');
            userAddItemValue = jm(this).val();
            userAddItemName = jm(this).attr('name');
            userAddItemMaxLength = jm(this).attr('maxlength');
            info[userAddItemID] = userAddItemValue;
            if (
                typeof userAddItemMaxLength != 'undefined' &&
                userAddItemMaxLength != null &&
                userAddItemValue.length > userAddItemMaxLength
            ) {
                mobiIng(
                    jm.format(
                        LS.memberSignupUserAddItemMaxLength,
                        userAddItemName,
                        userAddItemMaxLength
                    )
                );
                getPreviewObject(userAddItemID).focus();
                isUserAddItemNameTooLong = 1;
                return false;
            }
            if (userAddItemID == 'email' && userAddItemValue.length > 0) {
                if (!jm.isEmail(userAddItemValue)) {
                    mobiIng(
                        jm.format(
                            LS.memberSignupUserAddItemCorrect,
                            userAddItemName
                        )
                    );
                    getPreviewObject(userAddItemID).focus();
                    isUserAddItemPass = 1;
                    return false;
                }
            }
            if (userAddItemID == 'mobile' && userAddItemValue.length > 0) {
                if (!jm.isNationMobile(userAddItemValue)) {
                    mobiIng(LS.mobileNumRegular);
                    getPreviewObject(userAddItemID).focus();
                    isUserAddItemPass = 1;
                    return false;
                } else {
                    info['mobileCt'] = jm('#mobileCt').val();
                }
            }
        });

        if (isUserAddItemPass == 1) {
            return;
        }
        if (isUserAddItemNameTooLong == 1) {
            return;
        }

        // 判断验证码和手机验证码
        if (
            typeof jm('#messageAuthCode').attr('maxlength') != 'undefined' &&
            jm('#messageAuthCode').attr('maxlength') != null
        ) {
            var memberSignupCaptcha = jm('#memberSignupCaptcha').val();
            if (
                typeof memberSignupCaptcha == 'undefined' ||
                memberSignupCaptcha == null ||
                memberSignupCaptcha == ''
            ) {
                mobiIng(LS.memberInputCaptcha);
                return false;
            }

            var messageAuthCode = jm('#messageAuthCode').val();
            if (
                typeof messageAuthCode == 'undefined' ||
                messageAuthCode == null ||
                messageAuthCode == ''
            ) {
                mobiIng(LS.inputMobileCode);
                return false;
            }
            info['messageAuthCode'] = messageAuthCode;
        }

        var isCheckUAIStatus = 0;
        jm('.isCheckUAI').each(function () {
            let userAddItemID = jm(this).attr('id');
            userAddItemValue = jm(this).val();
            userAddItemName = jm(this).attr('name');
            if (userAddItemValue == null || userAddItemValue == '') {
                if (jm(this).is('input')) {
                    mobiIng(
                        jm.format(
                            LS.memberSignupUserAddItemIsEmpty,
                            userAddItemName
                        )
                    );
                } else {
                    mobiIng(
                        jm.format(
                            LS.memberSignupUserAddItemIsEmpty2,
                            userAddItemName
                        )
                    );
                }
                getPreviewObject(userAddItemID).focus();
                isCheckUAIStatus = 1;
                return false;
            }

            if (userAddItemID == 'email' && userAddItemValue.length > 0) {
                if (!jm.isEmail(userAddItemValue)) {
                    mobiIng(
                        jm.format(
                            LS.memberSignupUserAddItemCorrect,
                            userAddItemName
                        )
                    );
                    getPreviewObject(userAddItemID).focus();
                    isCheckUAIStatus = 1;
                    return false;
                }
            }
        });
        if (isCheckUAIStatus == 1) {
            return;
        }
    }

    request
        .post(`/ajax/member_h.jsp?${cmd}`, {
            data: {
                info,
                mid: srcMid,
                loginType,
            },
        })
        .catch(() => {
            mobiIng(LS.memberSignupRegisterError);
        })
        .then((res) => {
            let data = res.data;
            if (data.success) {
                if (data.fromBind) {
                    memberActive(data.mail, data.memName);
                } else {
                    if (data.active) {
                        memberActive(info.email, info.acct);
                    } else {
                        document.location.reload();
                    }
                }
            } else {
                if (data.msg == '该账号已绑定到其他账号') {
                    mobiIng(LS.hasBindOtherAcct);
                } else if (data.rt == -401) {
                    mobiIng(LS.memberSignupRegisterCaptchaNotMatch);
                } else if (data.rt == -601) {
                    mobiIng(LS.reGetMobileCode);
                } else if (data.rt == -8) {
                    mobiIng(LS.mobileHasSigned);
                } else if (data.rt == -6) {
                    mobiIng(LS.memberSignupRegisterExisted);
                } else if (data.rt == -4) {
                    mobiIng(LS.memberSignupRegisterLimit);
                } else if (data.rt == -3) {
                    mobiIng(LS.memberDialogNotFound);
                } else if (data.rt == otherLoginErrno.acctAlreadyBind) {
                    mobiIng(LS.memberOtherLgnAcctAlreadyBind);
                } else {
                    mobiIng(LS.memberSignupRegisterError);
                }
            }
        });
};

const checkHasMobileOption = function (optionList) {
    var hasMobile = false;
    let logAidList = [
        1591627, 24784076, 16835847, 15546092, 14346383, 24418638, 24434187,
        20343605, 23140239, 13940875,
    ];
    if (optionList) {
        // eslint-disable-next-line no-undef
        if (logAidList.includes(_aid)) {
            request.post('/login_h.jsp?cmd=wafNotCk_loginLog', {
                data: {
                    type: window._aid + '-wxWinListener-js-3',
                    data: 'checkHasMobileOption=' + jm.toJSON(optionList),
                },
            });
        }
        for (var i = 0; i < optionList.length; i++) {
            if (
                optionList[i]['fieldKey'] == 'mobile' &&
                optionList[i]['otherLoginMust']
            ) {
                hasMobile = true;
                break;
            }
        }
    }
    // eslint-disable-next-line no-undef
    if (logAidList.includes(_aid)) {
        request.post('/login_h.jsp?cmd=wafNotCk_loginLog', {
            data: {
                // eslint-disable-next-line no-undef
                type: _aid + '-wxWinListener-js-4',
                data: 'checkHasMobileOption=' + jm.toJSON(optionList),
            },
        });
    }
    return hasMobile;
};

// 绑定其他页面进入注册页面手机区号
const mSignUpPersInfoChangeMobileCt = function () {
    var mobleCtVal = jm('#mSignUp #mobileCt').val();
    var selectName = jm('#mSignUp #mobileCt')
        .find("option[value='" + mobleCtVal + "']")
        .html();
    jm('#mSignUp .selectCover').html(
        selectName.substring(selectName.indexOf('+'))
    );
};
